import React from 'react'
import { StyledChatMessagesList, StyledTextMessage } from './ChatMessages.style';
import Skeleton from 'react-loading-skeleton';

type Props = {}

const fakeData = [
  {width: 120, isSender: false},
  {width: 80, isSender: true},
  {width: 70, isSender: false},
  {width: 100, isSender: false},
  {width: 130, isSender: true},
  {width: 50, isSender: true},
  {width: 75, isSender: false},
]

const ChatMessagesSkeleton = () => {
  return (
    <StyledChatMessagesList className='chat-messages'>
      {
        fakeData.map(({isSender, width}, index) => (
          <StyledTextMessage isSkeleton isSender={isSender} key={index} className='chat-messages__item chat-messages__text'>
            <Skeleton count={1} height={32} borderRadius={ isSender ? '10px 10px 0 10px' : '10px 10px 10px 0' } width={width} className='make-offer__main-btn' />
          </StyledTextMessage>
        ))
      }
    </StyledChatMessagesList>
  )
}

export default ChatMessagesSkeleton;
